<template>
  <div id="">
    <div class="box-header">
      <div class="box-header-left">
        <div class="box-header-left-text">{{ title1 }}&nbsp;/&nbsp;</div>
        <div class="box-header-right">
          <div>{{ title2 }}</div>
        </div>
      </div>
    </div>
    <div class="question-detail">
      <div style="flex: 1;">
        <div class="top">
          <div class="flex margin24">
            <img
              :src="require('@/assets/image/question-back.png')"
              style="width: 40px; height: 40px;cursor: pointer;"
              @click="closeDetail"
            />
            <div class="map-content">
              <MapCom
                v-if="
                  detailHandleList.reportAddressLong &&
                    detailHandleList.reportAddressLat
                "
                :pointInfo="detailHandleList"
              ></MapCom>
            </div>
            <div class="right-top1">
              <div class="street">
                {{ detailHandleList.eventName }}（{{
                  detailHandleList.caseNumber
                }}）
                <div class="disposition">
                  <img
                    v-if="detailHandleList.transitionState202501 == '已处置'"
                    :src="require('@/assets/image/ycz.svg')"
                  />
                  <img
                    v-if="detailHandleList.transitionState202501 == '未处置'"
                    :src="require('@/assets/image/wcz.svg')"
                  />
                </div>
              </div>
              <div class="info-box">
                <div class="info-box-item">
                  <img src="@/assets/image/sbr.svg" alt="" />
                  <span style="color: #92979c">上报人</span>
                  <span>{{ detailHandleList.reportUserName }}</span>
                </div>
              </div>
              <div class="info-box">
                <div class="info-box-item">
                  <img src="@/assets/image/phone.svg" alt="" />
                  <span style="color: #92979c">联系方式</span>
                  <span>{{ detailHandleList.reportUserTel }}</span>
                </div>
              </div>
              <div class="info-box">
                <div class="info-box-item">
                  <img src="@/assets/image/clock.svg" alt="" />
                  <span style="color: #92979c">上报日期</span>
                  <span>{{ detailHandleList.reportTime }}</span>
                </div>
              </div>
              <div class="info-box">
                <div class="info-box-item">
                  <img src="@/assets/image/dianwei.svg" alt="" />
                  <span style="color: #92979c">上报地点</span>
                  <span>{{ detailHandleList.reportAddress }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="bottom">
          <div class="right-bottom">
            <div class="tabs">
              <div class="tabs-box">
                <div
                  class="tabs-item"
                  :class="{ active: curTab == item.value }"
                  v-for="(item, index) in tabsOptions"
                  :key="index"
                  @click="tabsChange(item)"
                >
                  {{ item.label }}
                </div>
              </div>
            </div>
            <div class="form-content">
              <el-form :model="pointInfoTemp" v-if="curTab == 1">
                  <div class="flex">
                    <el-form-item label="事项类型" style="width: 48%">
                      <el-input
                        disabled
                        v-model="pointInfoTemp.eventName"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="事项指标" style="width: 48%;margin-left: 20px;">
                      <el-input
                        disabled
                        v-model="pointInfoTemp.eventIndexName"
                      ></el-input>
                    </el-form-item>
                  </div>
                  <div class="flex">
                    <el-form-item
                      label="主办单位"
                      style="width: 48%;"
                    >
                      <el-input
                        disabled
                        v-model="pointInfoTemp.handleDeptName"
                      ></el-input>
                    </el-form-item>
                  </div>
                <div class="taskDetail">
                  <el-form-item
                    label="问题描述"
                    style="display: flex; flex-direction: column;width: calc(96% + 20px);"
                  >
                    <el-input
                      disabled
                      v-model="pointInfoTemp.taskDetail"
                    ></el-input>
                  </el-form-item>
                </div>
                <el-form-item
                  label="现场照片"
                  class="taskDetail"
                  style="display: flex; flex-direction: column"
                >
                  <div class="keyPic">
                    <el-image
                      class="imgPic"
                      v-for="(itempic, index) in pointInfoTemp.taskFileJsonList"
                      :key="index"
                      :src="itempic"
                      :preview-src-list="pointInfoTemp.taskFileJsonList"
                    >
                    </el-image>
                  </div>
                </el-form-item>
              </el-form>
              <div v-if="curTab == 2">
                <div class="flex" v-if="detailList.length">
                  <div class="fenbo">
                    <div
                      v-for="(item, index) in detailList"
                      @click="curClick(item, index)"
                      :key="index"
                      :class="[
                        'list',
                        curTabIndex == index ? 'activeList' : ''
                      ]"
                    >
                      <div class="flex">
                        <div class="handleDeptName">
                          {{ item.handleDeptName }}
                        </div>
                        <div
                          :class="[
                            'assignType',
                            item.assignType == '主办' ? 'zhuban' : ''
                          ]"
                        >
                          {{ item.assignType }}
                        </div>
                      </div>
                      <div class="flex assignTime">
                        <div>{{ item.assignTime }} 分拨</div>
                      </div>
                      <div class="disposition">
                        <img
                          v-if="
                            detailHandleList.transitionState202501 == '已处置'
                          "
                          :src="require('@/assets/image/ycz.svg')"
                        />
                        <img
                          v-if="
                            detailHandleList.transitionState202501 == '未处置'
                          "
                          :src="require('@/assets/image/wcz.svg')"
                        />
                      </div>
                    </div>
                  </div>
                  <div style="flex: 1">
                    <el-form :model="detailListForm">
                      <div class="flex">
                        <el-form-item label="处置人" style="width:50%;">
                          <el-input
                            disabled
                            v-model="detailListForm.handleUserName"
                          ></el-input>
                        </el-form-item>
                        <el-form-item
                          label="处置时间"
                          style="width:50%;margin-left: 20px"
                        >
                          <el-input
                            disabled
                            v-model="detailListForm.handleTime"
                          ></el-input>
                        </el-form-item>
                      </div>
                      <div class="taskDetail">
                        <el-form-item
                          label="处置措施"
                          style="display: flex; flex-direction: column"
                        >
                          <el-input
                            disabled
                            v-model="detailListForm.handleDetail"
                          ></el-input>
                        </el-form-item>
                      </div>
                      <el-form-item
                        label="现场照片"
                        class="taskDetail"
                        style="display: flex; flex-direction: column"
                      >
                        <div class="keyPic">
                          <el-image
                            class="imgPic"
                            v-for="(itempic,
                            index) in detailListForm.handleFileJson"
                            :key="index"
                            :src="itempic.url"
                            :preview-src-list="
                              detailListForm.handleFileJsonList
                            "
                          >
                          </el-image>
                        </div>
                      </el-form-item>
                    </el-form>
                  </div>
                </div>
                <div class="empty" v-else>
                  <div style="text-align: center">
                    <img src="@/assets/image/empty.png" alt="" />
                    <div>暂无数据</div>
                  </div>
                </div>
              </div>
              <!-- 错题处置备注 -->
              <div class="flex" v-if="curTab == 3" style="color: #494C4F;font-size: 16px; flex-direction: column;flex: 1;">
                <div>{{ pointInfoTemp.errDescribe }}</div>
                <div style="margin-top: 20px;">
                  <span>上报人: {{ pointInfoTemp.errCreateUsername }}</span>
                  <span style="margin-left: 30px;">{{pointInfoTemp.errCreateTime}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <flowRecord :id="pointInfo.taskId || pointInfo.id"></flowRecord>
    </div>
  </div>
</template>

<script>
import MapCom from "./map.vue";
import flowRecord from "./flowRecord.vue";
import { reportfullDetail } from "@/api/task.js";
export default {
  name: "",
  components: {
    MapCom,
    flowRecord
  },
  props: {
    pointInfo: {
      type: Object,
      default: () => ({})
    },
    title1: {
      type: String,
      default: ""
    },
    title2: {
      type: String,
      default: ""
    },
    // 显示错题审核 - 新标识
    showErrorQues: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tabsOptions: [
        {
          label: "上报详情",
          value: "1"
        },
        {
          label: "问题处置",
          value: "2"
        }
      ],
      curTab: "1",
      pointInfoTemp: {},
      detailHandleList: {},
      detailList: [],
      processLi: process.env.VUE_APP_API_IMG_PATH,
      detailListForm: {},
      curTabIndex: 0
    };
  },
  mounted() {
    this.pointInfoTemp = this.pointInfo;
    if (this.showErrorQues && this.pointInfoTemp.errAuditState == '通过') {
      this.tabsOptions.push({
        label: "错题处置备注",
        value: "3"
      });
    }
    this.qusetionDetail();
  },
  methods: {
    closeDetail() {
      this.$emit("closeDetail");
    },
    tabsChange(item) {
      this.curTab = item.value;
    },
    curClick(item, index) {
      this.detailListForm = item;
      this.curTabIndex = index;
      if (!this.detailListForm.handleFileJson) {
        this.detailListForm.handleFileJson = [];
        this.detailListForm.handleFileJsonList = [];
      } else {
        this.detailListForm.handleFileJson = JSON.parse(
          this.detailList.handleFileJson
        );
        this.detailListForm.handleFileJsonList = this.detailListForm.handleFileJson.map(
          item => item.url
        );
      }
    },

    async qusetionDetail() {
      // 获取详情
      const res = await reportfullDetail({
        id: this.pointInfoTemp.taskId || this.pointInfoTemp.id
      });
      if (res.data.code == 200) {
        this.detailHandleList = res.data.data;
        this.detailList = res.data.data.handleList;
        if (this.detailList.length > 0) {
          this.pointInfoTemp.handleDeptName = this.detailList[0].handleDeptName || '';
          this.detailListForm = this.detailList && this.detailList[0];
          if (!this.detailListForm.handleFileJson) {
            this.detailListForm.handleFileJson = [];
            this.detailListForm.handleFileJsonList = [];
          } else {
            this.detailListForm.handleFileJson = JSON.parse(
              this.detailListForm.handleFileJson
            );
            this.detailListForm.handleFileJsonList = this.detailListForm.handleFileJson.map(
              item => item.url
            );
          }
        }
        if (
          res.data.data.fileJson &&
          res.data.data.fileJsonZip &&
          res.data.data.fileJson.length == res.data.data.fileJsonZip.length
        ) {
          this.pointInfoTemp.taskFileJsonList = JSON.parse(
            res.data.data.fileJsonZip
          ).map(item => {
            return this.processLi + item.filePath;
          });
        } else {
          if (res.data.data.fileJson && res.data.data.fileJson.length)
            this.pointInfoTemp.taskFileJsonList = JSON.parse(
              res.data.data.fileJson
            ).map(item => {
              return item.url;
            });
        }
      }
    }
  },
  computed: {},
  watch: {}
};
</script>

<style scoped lang="less">
@import "~@/components/less.less";
.question-detail {
  height: calc(100% - 56px);
  background-color: #fff;
  border-radius: 8px 8px 0px 0px;
  display: flex;

  .top {
    width: 100%;
    // height: 178px;
    padding: 24px 20px;
    background: url("~@/assets/image/question-bg.png") no-repeat center;
    background-size: 100% 100%;
  }

  .map-content {
    width: 500px;
    height: 250px;
    margin: 0 12px;
  }
}

.right-top1 {
  // width: 100%;
  margin-bottom: 8px;
  padding: 10px 24px;
  position: relative;

  .street {
    font-family: MiSans, MiSans;
    font-weight: 700;
    font-size: 24px;
    color: #494c4f;
    position: relative;

    .disposition {
      position: absolute;
      top: -10px;
      right: -40px;

      img {
        width: 65px;
        height: 54px;
      }
    }
  }

  .content {
    margin-top: 8px;
    font-family: MiSans, MiSans;
    font-weight: 400;
    font-size: 18px;
    color: #494c4f;
  }

  .info-box {
    margin-top: 12px;
    display: flex;
    align-items: center;

    .info-box-item {
      display: flex;
      align-items: center;
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 16px;
      color: #494c4f;
      margin-right: 54px;

      img,
      span {
        margin-right: 8px;
      }

      img {
        height: 15px;
      }
    }

    .info-box-item:last-child {
      margin-right: 0;
    }
  }
}

.right-bottom {
  height: calc(100% - 214px);
  width: 100%;
  // max-height: 719px;
  // min-height: 561px;

  .tabs {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 20px;
    padding-right: 24px;
    margin-bottom: 8px;

    .tabs-box {
      display: flex;
      align-items: center;

      .tabs-item {
        padding-top: 10px;
        padding-bottom: 8px;
        font-family: MiSans, MiSans;
        font-weight: 400;
        font-size: 20px;
        color: #92979c;
        margin-right: 48px;
        cursor: pointer;
        position: relative;
      }

      .tabs-item.active {
        font-family: MiSans, MiSans;
        font-weight: 700;
        font-size: 20px;
        color: #494c4f;
      }

      .tabs-item.active::after {
        content: "";
        position: absolute;
        left: 0;
        bottom: 0;
        height: 4px;
        width: 100%;
        background: #0090ff;
        border-radius: 2px;
      }
    }

    .tupian-box {
      display: flex;
      align-items: center;

      width: 68px;

      .tupian-item {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        padding: 8px;
        height: 38px;
      }

      .tupian-item:first-child {
        border-radius: 4px 0px 0px 4px;
        border: 1px solid #e0e0e0;

        img {
          height: 16px;
        }
      }

      .tupian-item:last-child {
        border-radius: 0px 4px 4px 0px;
        border: 1px solid #e0e0e0;

        img {
          height: 20px;
        }
      }
    }
  }

  .map-content {
    width: 100%;
    height: calc(100% - 56px);
    // min-height: 505px;
  }
}

.form-content {
  padding: 20px;
}

.taskDetail {
  /deep/ .el-form-item__label {
    text-align: left;
  }
}

.keyPic {
  margin-top: 8px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;

  /deep/ .el-image {
    margin: 0 !important;
  }

  .imgPic {
    width: 234px;
    height: 234px;
    margin-right: 10px !important;
    border-radius: 4px;
  }
}

.fenbo {
  width: 360px;
  border-right: 1px solid #e0e0e0;
  margin-right: 20px;

  .list {
    width: 340px;

    height: 72px;
    background: #f7faff;
    border-radius: 4px;
    padding: 12px 24px;
    position: relative;
    margin-bottom: 12px;

    .handleDeptName {
      font-family: MiSans, MiSans;
      font-weight: 500;
      font-size: 16px;
      color: #494c4f;
      line-height: 22px;
    }

    .assignType {
      margin-right: 8px;
      padding: 0 4px;
      height: 22px;
      background: rgba(138, 144, 154, 0.09);
      border-radius: 4px;
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 14px;
      color: #92979c;
      line-height: 22px;
    }

    .zhuban {
      background: rgba(4, 149, 255, 0.1);
      color: #0495ff;
    }

    .assignTime {
      margin-top: 8px;
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 14px;
      color: #92979c;
      line-height: 19px;
    }

    .disposition {
      position: absolute;
      top: 10px;
      right: 20px;

      img {
        width: 65px;
        height: 54px;
      }
    }
  }

  .activeList {
    border: 1px solid #0495ff;
  }
}
.flex {
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/pages/reportproblemAnalysis/components/detail.vue